import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import {} from "src/_metronic/helpers";
import { SimpleModal } from "src/app/components";
import { useThematicsByRDT1Options } from "src/app/hooks";
import { SiteTransport } from "src/app/transports/site";
import { Site } from "src/app/types/Site";
import { IActionsModal } from "src/app/types/actionsModal";

const WordpressAccessFormBody = (props: IActionsModal<Site>) => {
    const { handleClose = () => {}, entity, updateGridOnSave = () => {} } = props;
    const { formatMessage } = useIntl();
    const [loading, setLoading] = useState<boolean>(false);

    const { thematicsOptions, refresh } = useThematicsByRDT1Options(entity?.id, false);
    useEffect(() => {
        if (entity && thematicsOptions.length === 0) {
            refresh();
        }
    }, [entity]);

    const onSubmit = async () => {
        setLoading(true);
        try {
            await SiteTransport.wordpressAccess(entity.id);
            toast.success(formatMessage({ id: "common.notification.success" }));
            handleClose();
        } catch (error: any) {
            toast.error(
                error?.response?.data?.errors[0]?.message ||
                    formatMessage({ id: "common.notification.error" })
            );
        } finally {
            setLoading(false);
        }
    };
    const Footer = (
        <Button onClick={handleClose}>{formatMessage({ id: "common.action.no" })}</Button>
    );
    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.entity.wordpressAccess" })}
            handleClose={() => {
                handleClose();
                updateGridOnSave({}, true);
            }}
            loading={loading}
            formId=""
            buttonConfirmationAction={onSubmit}
            buttonConfirmationLabel={formatMessage({ id: "common.action.yes" })}
            FooterLeftComponent={Footer}
            showModal={true}
            modalProps={{ size: "sm" }}
        >
            <div className="d-flex center">
                <label className="form-label">
                    {formatMessage({ id: "common.field.wordpressAccess" })}
                </label>
            </div>
        </SimpleModal>
    );
};

export default WordpressAccessFormBody;
